import React, { useRef, useState } from "react";
import styled from "styled-components";
import ReactionButton from "./ReactionButton";
import { useTranslate } from '@tolgee/react';
import { ReactComponent as ForwardedIcon } from "../../Assets/icons/forwardIcon.svg";

import Linkify from "linkify-react";
import ReplymessageElement from "./ReplyMessageElement";
import FileMessageComponent from "./FileMessageComponent";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";
import ReactionsContainer from "./ReactionsContainer";
import { useAuthService } from "../../Context/AuthContext";
import { downloadFile } from "../../Helpers/downloadHelper";


const DownloadIconSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 16L12 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 10L12 16L18 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 20H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const MessageReceived = ({
  originalText,
  sentTime,
  translatedText,
  language,
  image,
  handleReactToMessage,
  handleRemoveOwnMessageReaction,
  messageId,
  conversationId,
  reactions,
  handleShowFullScreenImg,
  messageDeleted,
  displayRightClickMenu,
  selectedConversation,
  messageUser,
  translatedFromLanguage,
  messageObject,
  forwarded,
  messageParent,
  file,
  video,
  onScroll,
}) => {
  const [showReactionButton, setShowReactionButton] = useState(false);
  const [showOriginalMessage, setShowOriginalMessage] = useState(false);
  const { automaticTranslations } = useGenericComponentsStateService();
  const longPressTimeout = useRef(null);

  const { user } = useAuthService();
  const { t } = useTranslate();

  let imageHeight = 400;
  let imageWidth = 350;

  const scaledHeightForMaxWidth = (scale) => {
    let aspectRatio = parseFloat(image.width) / parseFloat(image.height);
    let newHeight = scale / aspectRatio;
    return parseFloat(newHeight);
  };

  const scaledwidthForHeight = (scaledWidth) => {
    let aspectRatio = parseFloat(image.height) / parseFloat(image.width);
    let newWidth = scaledWidth / aspectRatio;
    return parseFloat(newWidth);
  };

  if (image) {
    if (window.innerWidth < 990) {
      imageHeight = scaledHeightForMaxWidth(300);
    } else {
      imageHeight = scaledHeightForMaxWidth(400);
    }

    imageWidth = scaledwidthForHeight(imageHeight);
  }


  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    longPressTimeout.current = setTimeout(() => {
      displayRightClickMenu(e, messageId, conversationId, messageObject);
    }, 500);
  };

  const handleTouchEnd = () => {
    clearTimeout(longPressTimeout.current);
  };

  const isSimpleConversation = (conversation) => {
    if (conversation.other_participants.length == 1) {
      return true;
    } else {
      return false;
    }
  };

  const getLanguageDisplayName = (language) => {
    if (language === "Unrecognizable") return t('chat.unrecognizable');
    if (language.includes(',')) {
      return language.split(',').map(lang => 
        t(`language_names.${lang.trim()}`, lang.trim())
      ).join(', ');
    }
    return t(`language_names.${language}`, language);
  };

  const onDownloadClick = (e, url, fileName) => {
    e.stopPropagation();
    downloadFile(url, fileName);
  };

  return (
    <Container
      id={`message-${messageId}`}
      onScroll={onScroll}
      className="infinite-item"
      onMouseEnter={() => {
        if (
          selectedConversation?.open == false ||
          (isSimpleConversation(selectedConversation) &&
            selectedConversation?.other_participants[0].blocked)
        ) {
          return;
        }
        setShowReactionButton(true);
      }}
      onMouseLeave={() => {
        setShowReactionButton(false);
      }}
    >
      <MessageWrapper
        onContextMenu={(e) =>
          displayRightClickMenu(e, messageId, conversationId, { ...messageObject, showOriginalMessage: showOriginalMessage })
        }
        onTouchStart={(e) => handleTouchStart(e)}
        onTouchEnd={handleTouchEnd}
      >
        {(selectedConversation.group || (selectedConversation.is_call_chat && selectedConversation.other_participants?.length > 1)) && (
          <UserNameWrapper>
            <p>{messageUser?.name}</p>
          </UserNameWrapper>
        )}

        <ConversationAndOptions>
          <ConversationMessage imgcontainer={image || video}>
            <ItemWrapper>
              {forwarded && (
                <ForwardedInfo image={image || video}>
                  <ForwardedIcon />
                  <p>Forwarded</p>
                </ForwardedInfo>
              )}
              {messageParent && !messageDeleted && (
                <ReplymessageElement
                  received
                  text={messageParent.original_message}
                  image={messageParent.image}
                  messageDeleted={messageParent.deleted}
                  sender={messageParent.user?.name}
                  file={messageParent.document}
                  video={messageParent.video}
                />
              )}

              {image && (
                <ImageWrapper>
                  <img
                    height={imageHeight}
                    width={imageWidth}
                    src={image.url}
                    alt="pht"
                    onClick={() =>
                      handleShowFullScreenImg(
                        image.url,
                        messageId,
                        conversationId
                      )
                    }
                  />
                
                  <DownloadOverlay 
                    onClick={(e) => onDownloadClick(e, image.url, image.name || "image.jpg")}
                    title={t("general.download", "Download")}
                  >
                    <DownloadIconSvg />
                  </DownloadOverlay>
                </ImageWrapper>
              )}

              {video && (
                <VideoPreview>
                    <VideoDownloadWrapper>
                        <video src={video.video_url} width={"100%"} controls></video>
                        <DownloadOverlay
                            onClick={(e) => onDownloadClick(e, video.video_url, "video.mp4")}
                            title={t("general.download", "Download")}
                        >
                            <DownloadIconSvg />
                        </DownloadOverlay>
                    </VideoDownloadWrapper>
                </VideoPreview>
              )}

              {file && (
                <FileMessageComponent 
                  file={file} 
                  received={true}
                  onDownload={() => downloadFile(file.url, file.name)} 
                />
              )}

              {(originalText.length > 0 ||
                translatedText?.translation.length > 0) && (
                  <TextWrapper image={image || video}>
                    <Linkify options={{ target: "_blank", className: "link" }}>
                      {showOriginalMessage ? (
                        <p>{originalText}</p>
                      ) : (
                        <p>{translatedText?.translation}</p>
                      )}
                    </Linkify>
                  </TextWrapper>
                )}

              {messageDeleted && (
                <h3>
                  <i>{t('chat.message_deleted')}</i>
                </h3>
              )}

              {reactions[0] && !messageDeleted && (
                <ReactionsContainer
                  reactions={reactions}
                  participants={selectedConversation?.other_participants}
                  adjustmentForSide={false}
                  handleRemoveOwnMessageReaction={handleRemoveOwnMessageReaction}
                  conversationId={conversationId}
                  messageId={messageId}
                />
              )}

              {originalText && automaticTranslations && (
                <MessageTranslationsWrapper image={image || video}>
                  <MessageTranslation>
                    <MessageTranslationLanguage>
                      {messageObject.translated_from_language}:{" "}
                    </MessageTranslationLanguage>
                    {originalText}
                  </MessageTranslation>
                </MessageTranslationsWrapper>
              )}
            </ItemWrapper>
          </ConversationMessage>

          {showReactionButton &&
            user && user?.id &&
            !messageDeleted &&
            !selectedConversation?.with_emotii && (
              <ReactionButton
                userId={user.id}
                messageId={messageId}
                conversationId={conversationId}
                reactions={reactions}
                handleReactToMessage={handleReactToMessage}
                handleRemoveOwnMessageReaction={handleRemoveOwnMessageReaction}
                setShowReactionButton={setShowReactionButton}
              />
            )}
        </ConversationAndOptions>

        <Details>
          <SendTime>
            <p>{!messageDeleted && sentTime}</p>
          </SendTime>
          <Status>
            {!messageDeleted &&
              originalText.length > 0 &&
              !automaticTranslations ? (
              showOriginalMessage ? (
                <p>
                  {" "}
                  - See{" "}
                  <span
                    onClick={() => setShowOriginalMessage(!showOriginalMessage)}
                  >
                    {t('chat.preffered_language')}
                  </span>
                </p>
              ) : (
                <p>
                  {" "}
                  - {t('chat.original_in')}{" "}
                  <span
                    onClick={() => setShowOriginalMessage(!showOriginalMessage)}
                  >
                    {" "}
                    {getLanguageDisplayName(translatedFromLanguage)}
                  </span>
                </p>
              )
            ) : (
              ""
            )}
          </Status>
        </Details>
      </MessageWrapper>
    </Container>
  );
};

export default MessageReceived;



const Container = styled.div`
  display: flex;
  align-items: center;
`;
const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  gap: 7px;
  position: relative;
  width: fit-content;
  max-width: 400px;
  @media (max-width: 990px) {
    max-width: 300px;
  }
`;
const ConversationAndOptions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  width: fit-content;
`;

const ConversationMessage = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.chat.receivedMessageBackground};
  padding: 16px;
  padding: ${(props) => (props.imgcontainer ? "4px" : "16px")};
  border-top-left-radius: ${(props) => (props.imgcontainer ? "4px" : "8px")};
  border-bottom-left-radius: ${(props) =>
    props.imgcontainer ? "4px" : "20px"};
  border-top-right-radius: ${(props) => (props.imgcontainer ? "4px" : "20px")};
  border-bottom-right-radius: ${(props) =>
    props.imgcontainer ? "4px" : "20px"};
  width: fit-content;
  position: relative;
  display: flex;
  align-items: center;

  h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: ${({ theme }) => theme.chat.receivedMessageTextColor};
    padding: 0 5px;
  }

  a {
    color: ${({ theme }) => theme.chat.receivedMessageTextColor};
  }
`;
const Details = styled.div`
  display: flex;
  gap: 5px;
  width: fit-content;
  align-items: start;
`;
const SendTime = styled.div`
  display: flex;
  align-items: center;

  p {
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    text-align: left;
    color: ${({ theme }) => theme.chat.sentTime};
  }
`;
const Status = styled.div`
  display: flex;
  align-items: center;

  p {
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    text-align: left;
    color: ${({ theme }) => theme.chat.sentTime};
  }
  span {
    cursor: pointer;
    font-weight: 600;
    color: ${({ theme }) => theme.chat.readIconColor};
  }
`;
const UserNameWrapper = styled.div`
  display: flex;
  justify-content: start;
  width: 100%;
  p {
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
    line-height: 19px;
    letter-spacing: 0px;
    text-align: left;
    color: ${({ theme }) => theme.chat.readIconColor};
  }
`;
const ForwardedInfo = styled.div`
  display: flex;
  gap: 3px;
  align-items: center;
  margin-top: ${(props) => (props.image ? "6px" : "")};
  padding: ${(props) => (props.image ? "0 8px" : "")};
  p {
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    text-align: left;
    color: ${({ theme }) => theme.chat.receivedMessageTextColor};
  }
  svg {
    max-height: 12px;
  }
`;
const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const ImageWrapper = styled.div`
  display: flex;
  position: relative;
  img {
    display: flex;
    width: auto;
    max-width: 100%;
    cursor: pointer;
    border-radius: 4px;
  }
  &:hover button {
    opacity: 1;
  }
`;


const DownloadOverlay = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  border: 1px solid rgba(255,255,255,0.8);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 99;
  padding: 0;
  outline: none;
  backdrop-filter: blur(2px);
  opacity: 0;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
    transform: scale(1.1);
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

const TextWrapper = styled.div`
  padding: ${(props) => (props.image ? "5px 8px" : "")};
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    text-align: left;
    color: ${({ theme }) => theme.chat.receivedMessageTextColor};
  }
`;
const VideoPreview = styled.div`
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
`;

const VideoDownloadWrapper = styled.div`
    position: relative;
    display: inline-block;
    width: 100%;
    &:hover button {
        opacity: 1;
    }
`;

const MessageTranslationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-top: 1px solid
    ${({ theme }) => theme.chat.translationMessageBorderColor};
  padding: ${(props) => (props.image ? "5px 8px" : "10px 0 0 0")};
`;
const MessageTranslation = styled.p`
  font-weight: 400;
  font-size: 15px;
  line-height: 17px;
  letter-spacing: 0px;
  vertical-align: middle;
  color: ${({ theme }) => theme.chat.translationMessageTextColorReceived};
`;
const MessageTranslationLanguage = styled.span`
  font-weight: 600;
`;